import React from 'react';
// import LoginForm from './LoginForm.js keep it';
import LoginForm from './LoginForm';

import './SignUpForm.css';

const LoginModal = ({ visible, onClose, onLoginSuccess }) => {
  if (!visible) return null;

  return (
<div
  className="modal"
  style={{
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.4)',
    backdropFilter: 'blur(4px)',
    zIndex: 2000,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    boxSizing: 'border-box',
  }}
  onClick={onClose}
>
  <div
    className="modal-content"
    style={{
      width: '100%',
      maxWidth: '400px',
      borderRadius: '12px',
      display: 'inline-block',
      overflow: 'hidden',
    }}
    onClick={(e) => e.stopPropagation()}
  >
    <LoginForm onLoginSuccess={onLoginSuccess} />
  </div>
</div>

  );
};

export default LoginModal;
